import React, { FC } from 'react';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

export const QuoteNumber: FC = () => {
  const { details, isUnauthorized } = useAppContext();
  return (
    <div data-testid="aqui-header-quote-number" className={styles.container}>
      {!isUnauthorized && (
        <>
          <div className={styles.quoteNumberTitle}>QUOTE NUMBER</div>
          <div>{details.quoteNumber}</div>
        </>
      )}
    </div>
  );
};
